import type { PropertyData } from '@raffle/ui';

// Mock property data for development
export const mockProperties: PropertyData[] = [
  {
    id: '1',
    title: 'Luxury Villa in Lekki Phase 1',
    description: 'Experience the epitome of luxury living in this stunning 5-bedroom villa located in the prestigious Lekki Phase 1. This masterpiece features modern architecture, a private pool, smart home automation, and breathtaking ocean views. Perfect for those who demand nothing but the best.',
    location: 'Lekki Phase 1, Lagos',
    marketValue: 450000000,
    ticketPrice: 1000,
    totalTickets: 10000,
    ticketsSold: 7234,
    drawDate: '2026-02-28T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&auto=format',
    ],
    features: ['5 Bedrooms', '6 Bathrooms', 'Private Pool', 'Smart Home', 'Ocean View', '4 Car Garage'],
  },
  {
    id: '2',
    title: 'Modern Penthouse in Victoria Island',
    description: 'Stunning penthouse apartment with panoramic views of the Lagos lagoon. This 4-bedroom masterpiece offers 360-degree views, a private rooftop terrace, and access to world-class amenities including a gym, spa, and concierge services.',
    location: 'Victoria Island, Lagos',
    marketValue: 380000000,
    ticketPrice: 1000,
    totalTickets: 12000,
    ticketsSold: 4521,
    drawDate: '2026-03-15T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format',
    ],
    features: ['4 Bedrooms', '5 Bathrooms', 'Rooftop Terrace', 'Lagoon View', 'Gym Access', '24/7 Security'],
  },
  {
    id: '3',
    title: 'Executive Mansion in Banana Island',
    description: 'The crown jewel of Nigerian real estate. This magnificent 7-bedroom mansion sits on over 2,000 sqm of prime Banana Island land. Features include a private cinema, wine cellar, tennis court, and staff quarters.',
    location: 'Banana Island, Lagos',
    marketValue: 850000000,
    ticketPrice: 1000,
    totalTickets: 10000,
    ticketsSold: 2156,
    drawDate: '2026-04-01T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&auto=format',
    ],
    features: ['7 Bedrooms', '8 Bathrooms', 'Private Cinema', 'Wine Cellar', 'Tennis Court', 'Staff Quarters'],
  },
  {
    id: '4',
    title: 'Beachfront Apartment in Oniru',
    description: 'Wake up to the sound of waves in this beautiful 3-bedroom beachfront apartment. Direct beach access, modern finishes, and a vibrant community make this the perfect coastal lifestyle property.',
    location: 'Oniru, Victoria Island',
    marketValue: 180000000,
    ticketPrice: 1000,
    totalTickets: 8000,
    ticketsSold: 6789,
    drawDate: '2026-02-20T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600573472591-ee6c563aaec3?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=1200&auto=format',
    ],
    features: ['3 Bedrooms', '4 Bathrooms', 'Beach Access', 'Pool', 'Gym', 'Parking'],
  },
  {
    id: '5',
    title: 'Serviced Apartment in Ikoyi',
    description: 'Premium 2-bedroom serviced apartment in the heart of Ikoyi. Fully furnished with high-end appliances, 24/7 power supply, and professional management services. Ideal for investment or personal use.',
    location: 'Ikoyi, Lagos',
    marketValue: 120000000,
    ticketPrice: 1000,
    totalTickets: 10000,
    ticketsSold: 8932,
    drawDate: '2026-02-15T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&auto=format',
    ],
    features: ['2 Bedrooms', '3 Bathrooms', 'Fully Furnished', '24/7 Power', 'Concierge', 'Pool'],
  },
  {
    id: '6',
    title: 'Garden Terrace in Ikeja GRA',
    description: 'Charming 4-bedroom terrace with a beautiful private garden in the serene Ikeja GRA. This family-friendly property offers spacious living areas, modern amenities, and excellent security.',
    location: 'Ikeja GRA, Lagos',
    marketValue: 95000000,
    ticketPrice: 1000,
    totalTickets: 12000,
    ticketsSold: 11456,
    drawDate: '2026-02-10T18:00:00Z',
    status: 'active',
    images: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600047509358-9dc75507daeb?w=1200&auto=format',
      'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=1200&auto=format',
    ],
    features: ['4 Bedrooms', '5 Bathrooms', 'Private Garden', 'BQ', 'Security', 'Parking'],
  },
];

// Mock tickets data
export interface MockTicket {
  id: string;
  userId: string;
  propertyId: string;
  ticketNumber: string;
  purchasePrice: number;
  purchasedAt: Date;
  status: 'active' | 'won' | 'lost' | 'refunded';
}

export const mockTickets: MockTicket[] = [
  {
    id: 't1',
    userId: 'user-1',
    propertyId: '1',
    ticketNumber: 'LV-001234',
    purchasePrice: 1000,
    purchasedAt: new Date('2024-01-15T10:30:00Z'),
    status: 'active',
  },
  {
    id: 't2',
    userId: 'user-1',
    propertyId: '1',
    ticketNumber: 'LV-001235',
    purchasePrice: 1000,
    purchasedAt: new Date('2024-01-15T10:30:00Z'),
    status: 'active',
  },
  {
    id: 't3',
    userId: 'user-1',
    propertyId: '2',
    ticketNumber: 'PH-002341',
    purchasePrice: 1000,
    purchasedAt: new Date('2024-01-18T14:20:00Z'),
    status: 'active',
  },
  {
    id: 't4',
    userId: 'user-1',
    propertyId: '4',
    ticketNumber: 'BA-003456',
    purchasePrice: 1000,
    purchasedAt: new Date('2024-01-10T09:15:00Z'),
    status: 'active',
  },
];

// Mock draws data
export interface MockDraw {
  id: string;
  propertyId: string;
  status: 'pending' | 'in-progress' | 'completed' | 'cancelled';
  scheduledDate: Date;
  executedAt?: Date;
  winnerTicketNumber?: string;
  winnerId?: string;
}

export const mockDraws: MockDraw[] = [
  {
    id: 'd1',
    propertyId: '1',
    status: 'pending',
    scheduledDate: new Date('2026-02-28T18:00:00Z'),
  },
  {
    id: 'd2',
    propertyId: '2',
    status: 'pending',
    scheduledDate: new Date('2026-03-15T18:00:00Z'),
  },
  {
    id: 'd3',
    propertyId: '3',
    status: 'pending',
    scheduledDate: new Date('2026-04-01T18:00:00Z'),
  },
  {
    id: 'd4',
    propertyId: '4',
    status: 'pending',
    scheduledDate: new Date('2026-02-20T18:00:00Z'),
  },
  {
    id: 'd5',
    propertyId: '5',
    status: 'completed',
    scheduledDate: new Date('2024-01-01T18:00:00Z'),
    executedAt: new Date('2024-01-01T18:05:00Z'),
    winnerTicketNumber: 'SA-007821',
    winnerId: 'user-99',
  },
];

// Get single property by ID
export const getPropertyById = (id: string): PropertyData | undefined => {
  return mockProperties.find((p) => p.id === id);
};

// Get featured property (highest value active)
export const getFeaturedProperty = (): PropertyData => {
  return mockProperties
    .filter((p) => p.status === 'active')
    .sort((a, b) => b.marketValue - a.marketValue)[0];
};

// Get properties by status
export const getPropertiesByStatus = (status: PropertyData['status']): PropertyData[] => {
  return mockProperties.filter((p) => p.status === status);
};
